import type { GUARDIAN_COLORS } from "../pois.ts";
import type { SimpatiaRarity } from "../simpatias.ts";

/**
 * Glifos da linguagem visual (doc 09, §2): todo conceito que a cor codifica tem também uma forma,
 * para quem não distingue as cores e para leitura rápida no meio da horda.
 */
export const GLYPHS = {
  /** Chefes, Guardiões e Dragão. */
  coroa: { char: "♛", name: "Coroa" },
  /** Monstros e fauna hostil. */
  presa: { char: "▼", name: "Presa" },
  /** Jogadores: hexágono com o número do slot dentro. */
  hexagono: { char: "⬢", name: "Hexágono" },
  /** Formas das gemas (o Relicário do mockup). */
  triangulo: { char: "▲", name: "Triângulo" },
  circulo: { char: "●", name: "Círculo" },
  quadrado: { char: "■", name: "Quadrado" },
  estrela: { char: "★", name: "Estrela" },
  losango: { char: "◆", name: "Losango" },
  /** Sem glifo (o neutro não é acento). */
  nenhum: { char: "", name: "Nenhum" },
} as const satisfies Record<string, { readonly char: string; readonly name: string }>;

export type GlyphId = keyof typeof GLYPHS;

export type GemColor = (typeof GUARDIAN_COLORS)[number]["color"];

/**
 * Forma de cada gema (o id é a cor antiga): no mundo e no Relicário a gema é branca e se reconhece
 * pela forma, porque as cores das gemas colidiam com as dos jogadores e do chefe (doc 09, §2.4). São
 * as formas que o Relicário já usava (F30) e as do mockup do dono, na ordem das gemas: ▲ ● ■ ★ ◆.
 */
export const GEM_SHAPES = {
  verde: "triangulo",
  azul: "circulo",
  vermelho: "quadrado",
  amarelo: "estrela",
  rosa: "losango",
} as const satisfies Record<GemColor, GlyphId>;

/**
 * Pips (◆) que dizem o nível sem cor (F60): tier do item (0 a 5; madeira sem pip) e raridade da Bênção
 * (Comum ◆, Rara ◆◆, Lendária ◆◆◆), no lugar das cores de tier e de raridade (o azul e o laranja
 * colidiam com o jogador 4 e os inimigos).
 */
export const PIP = "◆";

export function pips(n: number): string {
  return PIP.repeat(Math.max(0, Math.min(5, Math.floor(n))));
}

const RARITY_PIPS: Readonly<Record<SimpatiaRarity, number>> = { comum: 1, rara: 2, lendaria: 3 };

export function rarityPips(rarity: SimpatiaRarity): string {
  return pips(RARITY_PIPS[rarity]);
}
